import { stories } from '@/mocks/chigua';

export default function Stories() {
  return (
    <section id="stories" className="scroll-mt-16 py-12 md:py-16">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <div className="flex items-center gap-2">
              <span className="font-heading text-sm font-bold tracking-widest text-accent-700">深入报道 · 大图卡片流</span>
              <span className="h-px w-8 bg-accent-400" />
            </div>
            <h2 className="mt-2 font-heading text-2xl font-bold text-ink-900 md:text-3xl">
              标题先导，六条被反复引用的长文
            </h2>
          </div>
          <a
            href="#timeline"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('timeline')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="flex items-center gap-1.5 whitespace-nowrap text-sm font-medium text-accent-600 hover:text-accent-700"
          >
            查看全部 37 期档案
            <i className="ri-arrow-right-up-line" />
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {stories.map((s) => (
            <article
              key={s.id}
              className="group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-paper-200 bg-paper-50 transition-all hover:-translate-y-0.5 hover:border-accent-200"
            >
              <div className="relative overflow-hidden">
                <img
                  src={s.img}
                  alt={`${s.title} · 98吃瓜${s.tag}`}
                  className="h-[176px] w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
                />
                <span className="absolute left-3 top-3 rounded-full bg-ink-900/85 px-2.5 py-1 text-xs font-medium text-paper-50 backdrop-blur-sm">
                  {s.tag}
                </span>
              </div>

              <div className="flex flex-1 flex-col p-4 md:p-5">
                <div className="flex items-center gap-2 text-xs text-ink-400">
                  <span>{s.id}</span>
                  <span className="h-1 w-1 rounded-full bg-paper-300" />
                  <span>{s.read} 深度阅读</span>
                </div>
                <h3 className="mt-2 font-heading text-[17px] font-bold leading-snug text-ink-900 transition-colors group-hover:text-accent-700">
                  {s.title}
                </h3>
                <p className="mt-2 flex-1 text-[13px] leading-[1.75] text-ink-600">{s.excerpt}</p>
                <div className="mt-4 flex items-center justify-between border-t border-paper-200 pt-3">
                  <span className="text-xs text-ink-500">{s.author} · {s.date}</span>
                  <span className="flex h-7 w-7 items-center justify-center rounded-md bg-paper-100 text-accent-600 transition-colors group-hover:bg-accent-600 group-hover:text-paper-50">
                    <i className="ri-arrow-right-line text-sm" />
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}